import type { FaireProductEntity } from "../../entity_types/product";

export const p_x3g4ytjznr: FaireProductEntity = {
  token: "p_x3g4ytjznr",
  type: "product",
  name: "Dog Party Gift Bag - Medium",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/50423b46c7881da047fd6d1f9c8aaac005efbf1aadf81dceb30e568a94564b88.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f2895342a0989f77abb85ed8a08c00d506f44bbd37f67128346acfa3d6ac6e30.jpeg",
    "https://cdn.faire.com/fastly/bdc5b2769e8026f6a7c419d506c6f3f7d0ffc81e34aa57c90dd189b76d8ea47d.webp",
    "https://cdn.faire.com/fastly/b3a6ffe78c4cdce83a02ed14da1ed46d5371b7947d3fda5aaf04692d70134c88.webp",
  ],
  priceDollars: 3.5,
  description:
    "Yes, this gift bag is awesome. It's cute and fun and illustrated and might even outshine whatever you put inside! But it's that little die-cut tag that might just be the cutest thing we have ever seen. The Medium size is perfect for one of those really nice gifty candles. Or some of our other favorite gifts... assorted E. Frances products, 4-5 bags of chocolate chips, or 84 packs of gum. The Small size perfectly fits 2 to 5 boxes of Little Notes®. Or a chipmunk. The Large size fits 8 cans of new tennis balls or... you tell us what you get in there and give us some great ideas!",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:06.349Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
